var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Gifts"}},[_c('h1',[_vm._v("Gifts")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }